import Swiper, { Navigation } from 'swiper';

export default function initSingleSolutionHeader() : void {
    const $singleSolutionHeaders = document.querySelectorAll<HTMLElement>('.header-image-js-swiper');

    $singleSolutionHeaders.forEach($container => {
        new SingleSolutionHeader($container);
    });
}

class SingleSolutionHeader {
    $el: HTMLElement | null | undefined;

    constructor($el: HTMLElement | null) {
        this.$el = $el;
        this.init();
    }

    /**
     * Initialise le block
     *
     * @return {void}
     */
    init() {
        if (this.$el) {
            new Swiper(this.$el, {
                modules: [Navigation],
                slidesPerView: 'auto',
                loop: false,
                spaceBetween: 10,
                allowTouchMove: true,
                grabCursor: true,
                navigation: {
                    nextEl: '.slider-next',
                    prevEl: '.slider-prev',
                },
            });
        }
    }
}
